import { useEffect, useRef, useState } from "react";
import ReactMarkdown from "react-markdown";
import { iAxios } from "../../lib/utils";
import { Footer, LurkerHeader, TabFilter } from "../common/Helper";

const { useSearchParams, Link } = require("react-router-dom")

const DocMarkdown = (props) => {
    const [sp] = useSearchParams();
    const [content, setContent] = useState('');
    const {hasHeaderFooter} =props;

    const mdRef = useRef();
    useEffect(() => {
        let path = sp.get('path');
        if (!path) {
            path = 'faq'
        }
        setContent('Loading...')
        iAxios.get('/api/v1/auth/doc', {
            params: {
                path:`${path}.md`
            }
        }).then(resp => { 
            setContent(resp.data.data)
        })
    }, [sp.get('path')])

    // Standalone (/pages) supplies its own header/footer, so it needs its own
    // page frame (max-width, centering, padding). Inside the app shell (/docs)
    // the `.app-main__inner` already provides that frame — adding it again would
    // double the inset, so we drop it to keep padding consistent across pages.
    const frameStyle = hasHeaderFooter
        ? { minHeight: 'calc(100vh - 120px)', maxWidth: 'var(--ds-content-max)', margin: '0 auto', padding: 'var(--ds-space-6)' }
        : {};

    return <div className="ds-scope">
        {hasHeaderFooter && <LurkerHeader />}

        <div style={frameStyle}>
            {!hasHeaderFooter && <TabFilter name="path" filters={[
                "FAQ",
                "Download",
                "Privacy",
                "Terms",
            ]} />}

            <div
                className={`ds-panel zcalo-doc page-${sp.get('path') || 'faq'}`}
                style={{ padding: 'var(--ds-space-8)', marginTop: 'var(--ds-space-5)' }}
                ref={mdRef}
            >
                <ReactMarkdown>{content}</ReactMarkdown>
            </div>
        </div>
        {hasHeaderFooter && <Footer />}
    </div>;

}

export default DocMarkdown;